/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listFiles = /* GraphQL */ `
  query ListFiles($filePrefix: String!) {
    listFiles(filePrefix: $filePrefix) {
      fileKey
      fileName
      fileSize
      fileType
      lastModified
      __typename
    }
  }
`;
export const getUploadSignedUrl = /* GraphQL */ `
  query GetUploadSignedUrl(
    $fileKey: String!
    $fileSize: Float!
    $uploadId: String
    $chunkIndex: Int
  ) {
    getUploadSignedUrl(
      fileKey: $fileKey
      fileSize: $fileSize
      uploadId: $uploadId
      chunkIndex: $chunkIndex
    )
  }
`;
export const getDownloadSignedUrl = /* GraphQL */ `
  query GetDownloadSignedUrl($fileKey: String!) {
    getDownloadSignedUrl(fileKey: $fileKey)
  }
`;
export const getAuthInfo = /* GraphQL */ `
  query GetAuthInfo($userName: String!, $password: String!, $cmkId: String!) {
    getAuthInfo(userName: $userName, password: $password, cmkId: $cmkId) {
      idToken
      accessToken
      refreshToken
      __typename
    }
  }
`;
export const getOfficeInfo = /* GraphQL */ `
  query GetOfficeInfo($serialNumber: String!) {
    getOfficeInfo(serialNumber: $serialNumber) {
      serialNumber
      label
      pressType
      uploadCurve
      accessGroups
      iotName
      clientIp
      power
      boxIp
      remoteAccess
      enableTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOfficeInfos = /* GraphQL */ `
  query ListOfficeInfos(
    $serialNumber: String
    $filter: ModelOfficeInfoFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listOfficeInfos(
      serialNumber: $serialNumber
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        serialNumber
        label
        pressType
        uploadCurve
        accessGroups
        iotName
        clientIp
        power
        boxIp
        remoteAccess
        enableTime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getReferenceLine = /* GraphQL */ `
  query GetReferenceLine($serialNumber: String!, $type: String!) {
    getReferenceLine(serialNumber: $serialNumber, type: $type) {
      serialNumber
      type
      name
      value
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listReferenceLines = /* GraphQL */ `
  query ListReferenceLines(
    $serialNumber: String
    $type: ModelStringKeyConditionInput
    $filter: ModelReferenceLineFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listReferenceLines(
      serialNumber: $serialNumber
      type: $type
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        serialNumber
        type
        name
        value
        accessGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLoadDataEachProductDaily = /* GraphQL */ `
  query GetLoadDataEachProductDaily(
    $office: String!
    $date: AWSDate!
    $productId: Int!
  ) {
    getLoadDataEachProductDaily(
      office: $office
      date: $date
      productId: $productId
    ) {
      office
      date
      productId
      dataCount
      eccentricityX
      eccentricityY
      totalLoad
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listLoadDataEachProductDailies = /* GraphQL */ `
  query ListLoadDataEachProductDailies(
    $office: String
    $dateProductId: ModelLoadDataEachProductDailyPrimaryCompositeKeyConditionInput
    $filter: ModelLoadDataEachProductDailyFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLoadDataEachProductDailies(
      office: $office
      dateProductId: $dateProductId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        office
        date
        productId
        dataCount
        eccentricityX
        eccentricityY
        totalLoad
        accessGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLoadDataEachProductLastMonth = /* GraphQL */ `
  query GetLoadDataEachProductLastMonth(
    $office: String!
    $date: AWSDate!
    $productId: Int!
  ) {
    getLoadDataEachProductLastMonth(
      office: $office
      date: $date
      productId: $productId
    ) {
      office
      date
      productId
      dataCount
      eccentricityX
      eccentricityY
      totalLoad
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listLoadDataEachProductLastMonths = /* GraphQL */ `
  query ListLoadDataEachProductLastMonths(
    $office: String
    $dateProductId: ModelLoadDataEachProductLastMonthPrimaryCompositeKeyConditionInput
    $filter: ModelLoadDataEachProductLastMonthFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLoadDataEachProductLastMonths(
      office: $office
      dateProductId: $dateProductId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        office
        date
        productId
        dataCount
        eccentricityX
        eccentricityY
        totalLoad
        accessGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLoadDataEachShotDaily = /* GraphQL */ `
  query GetLoadDataEachShotDaily(
    $office: String!
    $date: AWSDate!
    $type: String!
  ) {
    getLoadDataEachShotDaily(office: $office, date: $date, type: $type) {
      office
      date
      type
      loadDistributionData
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listLoadDataEachShotDailies = /* GraphQL */ `
  query ListLoadDataEachShotDailies(
    $office: String
    $dateType: ModelLoadDataEachShotDailyPrimaryCompositeKeyConditionInput
    $filter: ModelLoadDataEachShotDailyFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLoadDataEachShotDailies(
      office: $office
      dateType: $dateType
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        office
        date
        type
        loadDistributionData
        accessGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLoadDataEachShotLastMonth = /* GraphQL */ `
  query GetLoadDataEachShotLastMonth(
    $office: String!
    $date: AWSDate!
    $type: String!
  ) {
    getLoadDataEachShotLastMonth(office: $office, date: $date, type: $type) {
      office
      date
      type
      loadDistributionData
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listLoadDataEachShotLastMonths = /* GraphQL */ `
  query ListLoadDataEachShotLastMonths(
    $office: String
    $dateType: ModelLoadDataEachShotLastMonthPrimaryCompositeKeyConditionInput
    $filter: ModelLoadDataEachShotLastMonthFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLoadDataEachShotLastMonths(
      office: $office
      dateType: $dateType
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        office
        date
        type
        loadDistributionData
        accessGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDiagnosticChartDataDaily = /* GraphQL */ `
  query GetDiagnosticChartDataDaily($office: String!, $date: String!) {
    getDiagnosticChartDataDaily(office: $office, date: $date) {
      office
      date
      createdDay
      companyName
      workNumber
      model
      useYears
      modelNumber
      dueDate
      creationResult
      shotCount {
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      dieHeightRange {
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      dieHeightCount {
        rise {
          value
          judge
          __typename
        }
        descent {
          value
          judge
          __typename
        }
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      clutchTime {
        start {
          value
          judge
          __typename
        }
        link {
          value
          judge
          __typename
        }
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      brakeTime {
        start {
          value
          judge
          __typename
        }
        brake {
          value
          judge
          __typename
        }
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      pointLeak {
        leftFront {
          value
          judge
          __typename
        }
        leftRear {
          value
          judge
          __typename
        }
        rightFront {
          value
          judge
          __typename
        }
        rightRear {
          value
          judge
          __typename
        }
        note
        __typename
      }
      cfErrorTemp {
        rollFeeder {
          value
          judge
          diff
          __typename
        }
        terminalFeeder {
          value
          judge
          diff
          __typename
        }
        other {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      cfErrorElect {
        rollFeeder {
          value
          judge
          diff
          __typename
        }
        terminalFeeder {
          value
          judge
          diff
          __typename
        }
        other {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      plErrorTemp {
        blank {
          value
          judge
          diff
          __typename
        }
        piler {
          value
          judge
          diff
          __typename
        }
        other {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      plErrorElect {
        blank {
          value
          judge
          diff
          __typename
        }
        piler {
          value
          judge
          diff
          __typename
        }
        other {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      coilRange {
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      rbMalfunction {
        df {
          value
          judge
          diff
          __typename
        }
        ld {
          value
          judge
          diff
          __typename
        }
        no1 {
          value
          judge
          diff
          __typename
        }
        no2 {
          value
          judge
          diff
          __typename
        }
        no3 {
          value
          judge
          diff
          __typename
        }
        ul {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      trErrorTemp {
        frontAmp {
          value
          judge
          diff
          __typename
        }
        frontLinear1 {
          value
          judge
          diff
          __typename
        }
        frontLinear2 {
          value
          judge
          diff
          __typename
        }
        rearAmp {
          value
          judge
          diff
          __typename
        }
        rearLinear1 {
          value
          judge
          diff
          __typename
        }
        rearLinear2 {
          value
          judge
          diff
          __typename
        }
        leftLift {
          value
          judge
          diff
          __typename
        }
        rightLift {
          value
          judge
          diff
          __typename
        }
        leftClamp {
          value
          judge
          diff
          __typename
        }
        rightClamp {
          value
          judge
          diff
          __typename
        }
        addAxis {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      trErrorPosi {
        frontFeed {
          value
          judge
          diff
          __typename
        }
        rearFeed {
          value
          judge
          diff
          __typename
        }
        leftLift {
          value
          judge
          diff
          __typename
        }
        rightLift {
          value
          judge
          diff
          __typename
        }
        leftClamp {
          value
          judge
          diff
          __typename
        }
        rightClamp {
          value
          judge
          diff
          __typename
        }
        addAxis {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      trErrorElect {
        frontFeed {
          value
          judge
          diff
          __typename
        }
        rearFeed {
          value
          judge
          diff
          __typename
        }
        leftLift {
          value
          judge
          diff
          __typename
        }
        rightLift {
          value
          judge
          diff
          __typename
        }
        leftClamp {
          value
          judge
          diff
          __typename
        }
        rightClamp {
          value
          judge
          diff
          __typename
        }
        addAxis {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      microInching {
        total {
          value
          judge
          __typename
        }
        magnet {
          value
          judge
          __typename
        }
        note
        __typename
      }
      other
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDiagnosticChartDataDailies = /* GraphQL */ `
  query ListDiagnosticChartDataDailies(
    $office: String
    $date: ModelStringKeyConditionInput
    $filter: ModelDiagnosticChartDataDailyFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDiagnosticChartDataDailies(
      office: $office
      date: $date
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        office
        date
        createdDay
        companyName
        workNumber
        model
        useYears
        modelNumber
        dueDate
        creationResult
        shotCount {
          total {
            value
            judge
            __typename
          }
          note
          __typename
        }
        dieHeightRange {
          total {
            value
            judge
            __typename
          }
          note
          __typename
        }
        dieHeightCount {
          rise {
            value
            judge
            __typename
          }
          descent {
            value
            judge
            __typename
          }
          total {
            value
            judge
            __typename
          }
          note
          __typename
        }
        clutchTime {
          start {
            value
            judge
            __typename
          }
          link {
            value
            judge
            __typename
          }
          total {
            value
            judge
            __typename
          }
          note
          __typename
        }
        brakeTime {
          start {
            value
            judge
            __typename
          }
          brake {
            value
            judge
            __typename
          }
          total {
            value
            judge
            __typename
          }
          note
          __typename
        }
        pointLeak {
          leftFront {
            value
            judge
            __typename
          }
          leftRear {
            value
            judge
            __typename
          }
          rightFront {
            value
            judge
            __typename
          }
          rightRear {
            value
            judge
            __typename
          }
          note
          __typename
        }
        cfErrorTemp {
          rollFeeder {
            value
            judge
            diff
            __typename
          }
          terminalFeeder {
            value
            judge
            diff
            __typename
          }
          other {
            value
            judge
            diff
            __typename
          }
          note
          __typename
        }
        cfErrorElect {
          rollFeeder {
            value
            judge
            diff
            __typename
          }
          terminalFeeder {
            value
            judge
            diff
            __typename
          }
          other {
            value
            judge
            diff
            __typename
          }
          note
          __typename
        }
        plErrorTemp {
          blank {
            value
            judge
            diff
            __typename
          }
          piler {
            value
            judge
            diff
            __typename
          }
          other {
            value
            judge
            diff
            __typename
          }
          note
          __typename
        }
        plErrorElect {
          blank {
            value
            judge
            diff
            __typename
          }
          piler {
            value
            judge
            diff
            __typename
          }
          other {
            value
            judge
            diff
            __typename
          }
          note
          __typename
        }
        coilRange {
          total {
            value
            judge
            __typename
          }
          note
          __typename
        }
        rbMalfunction {
          df {
            value
            judge
            diff
            __typename
          }
          ld {
            value
            judge
            diff
            __typename
          }
          no1 {
            value
            judge
            diff
            __typename
          }
          no2 {
            value
            judge
            diff
            __typename
          }
          no3 {
            value
            judge
            diff
            __typename
          }
          ul {
            value
            judge
            diff
            __typename
          }
          note
          __typename
        }
        trErrorTemp {
          frontAmp {
            value
            judge
            diff
            __typename
          }
          frontLinear1 {
            value
            judge
            diff
            __typename
          }
          frontLinear2 {
            value
            judge
            diff
            __typename
          }
          rearAmp {
            value
            judge
            diff
            __typename
          }
          rearLinear1 {
            value
            judge
            diff
            __typename
          }
          rearLinear2 {
            value
            judge
            diff
            __typename
          }
          leftLift {
            value
            judge
            diff
            __typename
          }
          rightLift {
            value
            judge
            diff
            __typename
          }
          leftClamp {
            value
            judge
            diff
            __typename
          }
          rightClamp {
            value
            judge
            diff
            __typename
          }
          addAxis {
            value
            judge
            diff
            __typename
          }
          note
          __typename
        }
        trErrorPosi {
          frontFeed {
            value
            judge
            diff
            __typename
          }
          rearFeed {
            value
            judge
            diff
            __typename
          }
          leftLift {
            value
            judge
            diff
            __typename
          }
          rightLift {
            value
            judge
            diff
            __typename
          }
          leftClamp {
            value
            judge
            diff
            __typename
          }
          rightClamp {
            value
            judge
            diff
            __typename
          }
          addAxis {
            value
            judge
            diff
            __typename
          }
          note
          __typename
        }
        trErrorElect {
          frontFeed {
            value
            judge
            diff
            __typename
          }
          rearFeed {
            value
            judge
            diff
            __typename
          }
          leftLift {
            value
            judge
            diff
            __typename
          }
          rightLift {
            value
            judge
            diff
            __typename
          }
          leftClamp {
            value
            judge
            diff
            __typename
          }
          rightClamp {
            value
            judge
            diff
            __typename
          }
          addAxis {
            value
            judge
            diff
            __typename
          }
          note
          __typename
        }
        microInching {
          total {
            value
            judge
            __typename
          }
          magnet {
            value
            judge
            __typename
          }
          note
          __typename
        }
        other
        accessGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
